import Slider from "react-slick";
import { useRef, useState } from "react";
import contentData from "./content6Data.json";

const Live = () => {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const { headerContent, features } = contentData;

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (current, next) => setCurrentSlide(next),
  };

  return (
    <section className="relative min-h-screen  pt-[200px]" id="Live">
      {/* Background Video */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          poster="/static/videos/wavebackgground.mp4"
        >
          <source src="/static/videos/wavebackgground.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/50" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 h-full items-center">
        {/* Header Content */}
        <div className="w-full lg:w-1/2 text-white text-center lg:text-left">
          <div className="leading-tight">
            {headerContent.title.map((line, index) => (
              <p key={index} className="uppercase text-3xl sm:text-4xl lg:text-5xl font-light tracking-wider">
                {line.text}
                {line.highlight && (
                  <span className={`${line.isHighlight ? 'text-[#0AF9FF]' : ''} font-bold`}>
                    {line.highlight}
                  </span>
                )}
              </p>
            ))}
            <p className="font-light text-lg tracking-wider mt-8">
              {headerContent.subtitle}
            </p>
          </div>
        </div>

        {/* Features */}
        <div className="w-full mt-28">
          {/* Desktop View */}
          <div className="hidden sm:flex w-full px-14 justify-between items-center">
            {features.map((feature, index) => (
              <div key={index} className="max-w-[250px] flex-col justify-center items-center text-center">
                <div className="flex justify-center items-center">
                  <p className="text-white text-lg font-normal">{feature.text}</p>
                </div>
                <div className="flex justify-center items-center mt-6">
                  <div 
                    className="rounded-full w-10 h-10" 
                    style={{ 
                      backgroundColor: feature.dotColor,
                      boxShadow: `0 0 20px ${feature.dotColor}80`
                    }} 
                  />
                </div>
              </div>
            ))}
          </div>
          
          {/* Mobile Carousel */}
          <div className="sm:hidden w-full relative">
            <Slider ref={sliderRef} {...settings}>
              {features.map((feature, idx) => (
                <div key={idx} className="outline-none">
                  <div className="flex flex-col items-center justify-center px-4">
                    <div className="flex justify-center items-center">
                      <p className="text-white text-lg font-normal text-center">{feature.text}</p>
                    </div>
                    <div className="flex justify-center items-center mt-6">
                      <div 
                        className="rounded-full w-10 h-10" 
                        style={{ 
                          backgroundColor: feature.dotColor,
                          boxShadow: `0 0 20px ${feature.dotColor}80`
                        }} 
                      />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Live;